import { canEditSnProductMappingIdentity } from './snProductMappingStatus';
import { composeProductCode, splitProductCode } from './productCode';

export const SN_PRODUCT_MAPPING_FORM_DEFAULTS = {
  identityLocked: false,
  customerId: '',
  prefix: '',
  codeDigits: '',
  productCode: '',
  productName: '',
  remark: '',
};

/**
 * @param {object} detail
 * @param {string[]} prefixes
 */
export function mapSnProductMappingDetailToForm(detail, prefixes = []) {
  const identityLocked = !canEditSnProductMappingIdentity(detail?.status);
  const customerId = detail?.customerId ?? '';
  const productCode = detail?.productCode ?? '';
  const split = customerId ? splitProductCode(productCode, prefixes) : { prefix: '', digits: '' };

  return {
    identityLocked,
    customerId: customerId || '',
    prefix: split.prefix,
    codeDigits: split.digits,
    productCode,
    productName: detail?.productName ?? '',
    remark: detail?.remark ?? '',
  };
}

/**
 * 組出送給 serialize 的 camelCase。有客戶時用前綴加數字段。
 *
 * @param {object} values
 * @param {string|null} updatedAt
 */
export function buildSnProductMappingWriteValues(values, updatedAt) {
  const identityLocked = Boolean(values.identityLocked);
  const customerId = values.customerId || '';
  const productCode = identityLocked
    ? String(values.productCode ?? '').trim().toUpperCase()
    : (customerId
      ? composeProductCode(values.prefix, values.codeDigits)
      : String(values.productCode ?? '').trim().toUpperCase());

  return {
    identityLocked,
    customerId,
    productCode,
    productName: String(values.productName ?? '').trim(),
    remark: values.remark ?? '',
    updatedAt,
  };
}
